import { useEffect } from "react";
import { useQuestionizerStore } from "../types/state";
import StepButtons from "./step-buttons";
import StepNavigation from "./step-navigation";

import LoadingIndicator from "./loading-indicator.tsx";
//import QuestionizerResult from "./questionizer-result.tsx";
import QuestionizerForm from "./questionizer-form.tsx";

export default function Questionizer(props: {children?: ReactNode | Array<ReactNode>}){
  //const step = useQuestionizerStore((state) => state.step);
  //const step_count = useQuestionizerStore((state) => state.stepsCount());

  const config = useQuestionizerStore((state) => state.config);
  const session_id = useQuestionizerStore((state) => state.session_id);
  const session_id_timestamp = useQuestionizerStore((state) => state.session_id_timestamp);
  const requestSessionId = useQuestionizerStore((state) => state.requestSessionId);
  const pdf_link = useQuestionizerStore((state) => state.pdf_link);
  const contrast_mode = useQuestionizerStore((state) => state.contrast_mode);
  const translation = useQuestionizerStore((state) => state.translation);
  const step = useQuestionizerStore((state) => state.step);  

  useEffect(() => {
    if (config?.use_pdf_download && pdf_link){
      window.open(pdf_link!);
    }
  }, [pdf_link])

   useEffect(() => {
    if(session_id === undefined || session_id_timestamp === undefined || (session_id_timestamp + 43200000) < Date.now()){
        requestSessionId();
    }
  }, [config]);
  
  if (!config || !session_id){
    return <LoadingIndicator />
  }

  return (
      <div role="main" className={contrast_mode?"contrast_mode":""}>
         {config.info_top && (
			  <p className="form__info-top" role="text">
				{translation.labels[config.info_top] || config.info_top}
			  </p>
			)}
          <StepNavigation />
          {
            props.children && step == 0?
            props.children :
            <QuestionizerForm />
          }
          <StepButtons />
         {config.info_bottom && (
			  <p className="form__info-bottom" role="text">
				{translation.labels[config.info_bottom] || config.info_bottom}
			  </p>
			)}
      </div>
  ); 
}
